<template>
	<div class="icon_language_box">
		<label for="select_language"><span class="icon_language"></span></label>
		<select v-model="s_locale_code" id="select_language">
			<option v-for="item in locales" :value="item.code" :key="item.code">
				{{ item.name }}
			</option>
		</select>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'menuLang',
	computed: {
		...mapState('common', ['locales']),
		s_locale_code: {
			get() {
				return this.$store.state.common.locale;
			},
			set(value) {
				this.$store.dispatch('common/setLocale', value);
			},
		},
	},
};
</script>
